import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

import AccessErrorPage from "@/components/pages/AccessErrorPage.vue";
import EventDetailPage from "@/components/pages/EventDetailPage.vue";
import EventPage from "@/components/pages/EventPage.vue";
import NotFoundPage from "@/components/pages/NotFoundPage.vue";
import NotificationPolicyPage from "@/components/pages/NotificationPolicyPage.vue";
import RedirectPage from "@/components/pages/RedirectPage.vue";
import ServicePage from "@/components/pages/ServicePage.vue";
import ServiceStatusPage from "@/components/pages/ServiceStatusPage.vue";
import ImportantOldPage from "@/components/pages/ImportantOldPage.vue";
import Summary20230220Page from "@/components/pages/news/Summary20230220Page.vue";
import Powermsp20230220Page from "@/components/pages/news/Powermsp20230220Page.vue";
import { RouteName } from "@/consts/route";
import { RouteUtil } from "@/utils/route.util";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: RouteName.Home,
    component: ServicePage,
  },
  {
    path: "/not-found",
    name: RouteName.NotFound,
    component: NotFoundPage,
  },
  {
    path: "/access-error",
    name: RouteName.AccessError,
    component: AccessErrorPage,
  },

// 不要なページへのリンクのためコメントアウト(2022/7/7)
//   {
//     path: "/policy",
//     name: RouteName.NotificationPolicy,
//     component: NotificationPolicyPage,
//   },

  {
    path: "/important-past",
    name: RouteName.ImportantOld,
    component: ImportantOldPage,
  },
  {
    path: "/:key",
    name: RouteName.Service,
    component: ServicePage,
  },
  {
    path: "/:key/status",
    name: RouteName.ServiceStatus,
    component: ServiceStatusPage,
  },
  {
    path: "/:key/status/:serviceMenuId",
    name: RouteName.EventList,
    component: EventPage,
  },
  {
    path: "/:key/status/:serviceMenuId/message/:eventId",
    name: RouteName.EventDetail,
    component: EventDetailPage,
  },
  {
    // News
    path: "/news/20230220-summary",
      name: RouteName.Summary20230220,
      component: Summary20230220Page,
  },
  {
    // News
    path: "/news/20230220-powermsp",
      name: RouteName.Powermsp20230220,
      component: Powermsp20230220Page,
  },
  {
    // 画面遷移用
    path: "/r/:name",
    name: RouteName.Redirect,
    component: RedirectPage,
    props: (route): unknown => {
      return { name: route.params.name };
    },
  },
  {
    path: "/*",
    name: RouteName.NotFound,
    component: NotFoundPage,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

RouteUtil.replacePush(router);

export default router;
